// Copyright 2013 Traceur Authors.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// This file was auto generated by build-parse-tree-type.js
// from trees.json
// Do not edit!

export const ANNOTATION = 'ANNOTATION';
export const ANON_BLOCK = 'ANON_BLOCK';
export const ARGUMENT_LIST = 'ARGUMENT_LIST';
export const ARRAY_COMPREHENSION = 'ARRAY_COMPREHENSION';
export const ARRAY_LITERAL = 'ARRAY_LITERAL';
export const ARRAY_PATTERN = 'ARRAY_PATTERN';
export const ARRAY_TYPE = 'ARRAY_TYPE';
export const ARROW_FUNCTION = 'ARROW_FUNCTION';
export const ASSIGNMENT_ELEMENT = 'ASSIGNMENT_ELEMENT';
export const AWAIT_EXPRESSION = 'AWAIT_EXPRESSION';
export const BINARY_EXPRESSION = 'BINARY_EXPRESSION';
export const BINDING_ELEMENT = 'BINDING_ELEMENT';
export const BINDING_IDENTIFIER = 'BINDING_IDENTIFIER';
export const BLOCK = 'BLOCK';
export const BREAK_STATEMENT = 'BREAK_STATEMENT';
export const CALL_EXPRESSION = 'CALL_EXPRESSION';
export const CALL_SIGNATURE = 'CALL_SIGNATURE';
export const CASE_CLAUSE = 'CASE_CLAUSE';
export const CATCH = 'CATCH';
export const CLASS_DECLARATION = 'CLASS_DECLARATION';
export const CLASS_EXPRESSION = 'CLASS_EXPRESSION';
export const COMMA_EXPRESSION = 'COMMA_EXPRESSION';
export const COMPREHENSION_FOR = 'COMPREHENSION_FOR';
export const COMPREHENSION_IF = 'COMPREHENSION_IF';
export const COMPUTED_PROPERTY_NAME = 'COMPUTED_PROPERTY_NAME';
export const CONDITIONAL_EXPRESSION = 'CONDITIONAL_EXPRESSION';
export const CONSTRUCT_SIGNATURE = 'CONSTRUCT_SIGNATURE';
export const CONSTRUCTOR_TYPE = 'CONSTRUCTOR_TYPE';
export const CONTINUE_STATEMENT = 'CONTINUE_STATEMENT';
export const COVER_FORMALS = 'COVER_FORMALS';
export const COVER_INITIALIZED_NAME = 'COVER_INITIALIZED_NAME';
export const DEBUGGER_STATEMENT = 'DEBUGGER_STATEMENT';
export const DEFAULT_CLAUSE = 'DEFAULT_CLAUSE';
export const DO_WHILE_STATEMENT = 'DO_WHILE_STATEMENT';
export const EMPTY_STATEMENT = 'EMPTY_STATEMENT';
export const EXPORT_DECLARATION = 'EXPORT_DECLARATION';
export const EXPORT_DEFAULT = 'EXPORT_DEFAULT';
export const EXPORT_SPECIFIER = 'EXPORT_SPECIFIER';
export const EXPORT_SPECIFIER_SET = 'EXPORT_SPECIFIER_SET';
export const EXPORT_STAR = 'EXPORT_STAR';
export const EXPRESSION_STATEMENT = 'EXPRESSION_STATEMENT';
export const FINALLY = 'FINALLY';
export const FOR_IN_STATEMENT = 'FOR_IN_STATEMENT';
export const FOR_OF_STATEMENT = 'FOR_OF_STATEMENT';
export const FOR_ON_STATEMENT = 'FOR_ON_STATEMENT';
export const FOR_STATEMENT = 'FOR_STATEMENT';
export const FORMAL_PARAMETER = 'FORMAL_PARAMETER';
export const FORMAL_PARAMETER_LIST = 'FORMAL_PARAMETER_LIST';
export const FORWARD_DEFAULT_EXPORT = 'FORWARD_DEFAULT_EXPORT';
export const FUNCTION_BODY = 'FUNCTION_BODY';
export const FUNCTION_DECLARATION = 'FUNCTION_DECLARATION';
export const FUNCTION_EXPRESSION = 'FUNCTION_EXPRESSION';
export const FUNCTION_TYPE = 'FUNCTION_TYPE';
export const GENERATOR_COMPREHENSION = 'GENERATOR_COMPREHENSION';
export const GET_ACCESSOR = 'GET_ACCESSOR';
export const IDENTIFIER_EXPRESSION = 'IDENTIFIER_EXPRESSION';
export const IF_STATEMENT = 'IF_STATEMENT';
export const IMPORT_CLAUSE_PAIR = 'IMPORT_CLAUSE_PAIR';
export const IMPORT_DECLARATION = 'IMPORT_DECLARATION';
export const IMPORT_SPECIFIER = 'IMPORT_SPECIFIER';
export const IMPORT_SPECIFIER_SET = 'IMPORT_SPECIFIER_SET';
export const IMPORT_TYPE_CLAUSE = 'IMPORT_TYPE_CLAUSE';
export const IMPORTED_BINDING = 'IMPORTED_BINDING';
export const INDEX_SIGNATURE = 'INDEX_SIGNATURE';
export const INTERFACE_DECLARATION = 'INTERFACE_DECLARATION';
export const JSX_ATTRIBUTE = 'JSX_ATTRIBUTE';
export const JSX_ELEMENT = 'JSX_ELEMENT';
export const JSX_ELEMENT_NAME = 'JSX_ELEMENT_NAME';
export const JSX_PLACEHOLDER = 'JSX_PLACEHOLDER';
export const JSX_SPREAD_ATTRIBUTE = 'JSX_SPREAD_ATTRIBUTE';
export const JSX_TEXT = 'JSX_TEXT';
export const LABELLED_STATEMENT = 'LABELLED_STATEMENT';
export const LITERAL_EXPRESSION = 'LITERAL_EXPRESSION';
export const LITERAL_PROPERTY_NAME = 'LITERAL_PROPERTY_NAME';
export const MEMBER_EXPRESSION = 'MEMBER_EXPRESSION';
export const MEMBER_LOOKUP_EXPRESSION = 'MEMBER_LOOKUP_EXPRESSION';
export const METHOD = 'METHOD';
export const METHOD_SIGNATURE = 'METHOD_SIGNATURE';
export const MODULE = 'MODULE';
export const MODULE_SPECIFIER = 'MODULE_SPECIFIER';
export const NAME_SPACE_EXPORT = 'NAME_SPACE_EXPORT';
export const NAME_SPACE_IMPORT = 'NAME_SPACE_IMPORT';
export const NAMED_EXPORT = 'NAMED_EXPORT';
export const NEW_EXPRESSION = 'NEW_EXPRESSION';
export const OBJECT_LITERAL = 'OBJECT_LITERAL';
export const OBJECT_PATTERN = 'OBJECT_PATTERN';
export const OBJECT_PATTERN_FIELD = 'OBJECT_PATTERN_FIELD';
export const OBJECT_TYPE = 'OBJECT_TYPE';
export const PAREN_EXPRESSION = 'PAREN_EXPRESSION';
export const POSTFIX_EXPRESSION = 'POSTFIX_EXPRESSION';
export const PREDEFINED_TYPE = 'PREDEFINED_TYPE';
export const PROPERTY_NAME_ASSIGNMENT = 'PROPERTY_NAME_ASSIGNMENT';
export const PROPERTY_NAME_SHORTHAND = 'PROPERTY_NAME_SHORTHAND';
export const PROPERTY_SIGNATURE = 'PROPERTY_SIGNATURE';
export const PROPERTY_VARIABLE_DECLARATION = 'PROPERTY_VARIABLE_DECLARATION';
export const REST_PARAMETER = 'REST_PARAMETER';
export const RETURN_STATEMENT = 'RETURN_STATEMENT';
export const SCRIPT = 'SCRIPT';
export const SET_ACCESSOR = 'SET_ACCESSOR';
export const SPREAD_EXPRESSION = 'SPREAD_EXPRESSION';
export const SPREAD_PATTERN_ELEMENT = 'SPREAD_PATTERN_ELEMENT';
export const STATE_MACHINE = 'STATE_MACHINE';
export const SUPER_EXPRESSION = 'SUPER_EXPRESSION';
export const SWITCH_STATEMENT = 'SWITCH_STATEMENT';
export const SYNTAX_ERROR_TREE = 'SYNTAX_ERROR_TREE';
export const TEMPLATE_LITERAL_EXPRESSION = 'TEMPLATE_LITERAL_EXPRESSION';
export const TEMPLATE_LITERAL_PORTION = 'TEMPLATE_LITERAL_PORTION';
export const TEMPLATE_SUBSTITUTION = 'TEMPLATE_SUBSTITUTION';
export const THIS_EXPRESSION = 'THIS_EXPRESSION';
export const THROW_STATEMENT = 'THROW_STATEMENT';
export const TRY_STATEMENT = 'TRY_STATEMENT';
export const TYPE_ALIAS_DECLARATION = 'TYPE_ALIAS_DECLARATION';
export const TYPE_ARGUMENTS = 'TYPE_ARGUMENTS';
export const TYPE_NAME = 'TYPE_NAME';
export const TYPE_PARAMETER = 'TYPE_PARAMETER';
export const TYPE_PARAMETERS = 'TYPE_PARAMETERS';
export const TYPE_REFERENCE = 'TYPE_REFERENCE';
export const UNARY_EXPRESSION = 'UNARY_EXPRESSION';
export const UNION_TYPE = 'UNION_TYPE';
export const VARIABLE_DECLARATION = 'VARIABLE_DECLARATION';
export const VARIABLE_DECLARATION_LIST = 'VARIABLE_DECLARATION_LIST';
export const VARIABLE_STATEMENT = 'VARIABLE_STATEMENT';
export const WHILE_STATEMENT = 'WHILE_STATEMENT';
export const WITH_STATEMENT = 'WITH_STATEMENT';
export const YIELD_EXPRESSION = 'YIELD_EXPRESSION';
